angular.module('aprima-legacy-common').value('moment', window.moment);

(function() {
    'use strict';

    var messageTypes = {
        LabResultMessageGuid: '',
        TaskMessageGuid: '10101010-0000-0000-0000-000000000005',
        PortalAppointmentQuestionMessageGuid: 'fd4e2c5d-29c6-4a51-bd20-551d6ed90843',
        PortalBillingQuestionMessageGuid: '73366ba8-0149-47e0-875b-cb12bb4cb250',
        PortalDemographicsQuestionMessageGuid: 'dffb40d0-2318-41a9-8eef-94c58babb9b9',
        PortalGeneralQuestionMessageGuid: '9af1089b-e98b-4758-80f8-0435b143426d',
        PortalRxQuestionMessageGuid: 'e94b7146-407d-4f92-a393-de8429b7bfbf',
        PhoneMessageGuid: '10101010-0000-0000-0000-000000000003',
        LabMessageGuid: 'f05f9c71-a893-46c3-a7fe-37988f48a782',
        AttachmentApprovalGuid: '10101010-0000-0000-0000-000000000002',
        ServiceOrderApprovalMessageGuid: '10101010-0000-0000-0000-000000000008',

        // These refill message types still need to be handled to keep compatibility with older versions of PRM
        // where they are still commonly used.
        // Also, there still could be messages of this type in the database even in newer versions of PRM that were created
        // before the upgrade where this new message type below was introduced.
        // We may want to handle these differently at some point
        RxRefillRequestMessageGuid: '136d8762-82ec-487d-9448-f52469a3cdcd',
        PatientRxRefillRequestMessageGuid: 'b1b7d286-1fb2-43d0-a883-7946b1cd8751',
        PharmacyRefillRequestMessageGuid: 'd7716f70-61d6-4ec0-8ba6-01afc95e99f2',

        // This is the new message type that was recently created.
        // Description: Messages of this type are created by the user as part of the manual and electronic Rx Refill workflow.
        // Also, currently the patient portal rx refill request messages are a subtype of this message type.
        RxRefillAndErxRequestMessageGuid: 'eb31df6b-3685-4639-81f6-026f6278e1dc',
    };

    messageTypes.SupportedMessageTypesForCreate = {
        Types: [{id: messageTypes.TaskMessageGuid}, {id: messageTypes.PhoneMessageGuid, requiredFeature: 'PhoneMessageCreation'}],
        SubTypes: [{id: messageTypes.PortalGeneralQuestionMessageGuid}]
    };

    var appointmentScheduleTypes = {
        PatientVisit: {
            id: 'patientvisit',
            name: 'Patient Visit'
        },
        Event: {
            id: 'event',
            name: 'Event',
            requiredFeature: 'Appointments_DifferentScheduleTypes'
        },
        BlockingEvent: {
            id: 'blockingevent',
            name: 'Blocking Event',
            requiredFeature: 'Appointments_DifferentScheduleTypes'
        },
        GroupVisit: {
            id: 'groupvisit',
            name: 'Group Visit',
            requiredFeature: 'Appointments_DifferentScheduleTypes'
        }
    };
    appointmentScheduleTypes.List = _.values(appointmentScheduleTypes);

    var requestTypes = {
        listData: 'listData',
        default: 'default'
    };

    angular.module('aprima-legacy-common').constant('MessageTypes', messageTypes);
    angular.module('aprima-legacy-common').constant('AppointmentScheduleTypes', appointmentScheduleTypes);
    angular.module('aprima-legacy-common').constant('RequestTypes', requestTypes);
})();